import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4 bg-white" data-id="element-56">
      <div className="max-w-3xl mx-auto bg-brand-cream/50 rounded-3xl p-8 md:p-12 border border-brand-gold/30 text-center" data-id="element-57">
        <div className="flex justify-center mb-6" data-id="element-58">
          <div className="bg-brand-gold/20 p-4 rounded-full" data-id="element-59">
            <ShieldCheckIcon className="w-16 h-16 text-brand-gold" data-id="element-60" />
          </div>
        </div>

        <h2 className="text-3xl font-bold text-brand-green mb-4" data-id="element-61">
          Garantía Total de 45 Días
        </h2>

        <p className="text-lg text-gray-700 mb-6" data-id="element-62">
          Una vez que completes tu compra vas a poder descargar el libro y
          empezar a aplicar la información inmediatamente. Además tenés garantía
          total.
        </p>

        <p className="text-xl font-medium text-brand-green mb-4" data-id="element-63">
          Si por cualquier motivo sentís que este contenido no te ayudó, podés
          pedir el reembolso y te devolvemos el dinero.
        </p>

        <p className="text-2xl font-bold text-brand-red uppercase tracking-wider" data-id="element-64">
          Sin preguntas.
        </p>
      </div>
    </section>;
}